import type { FC } from 'react';
import { StyledLink, type LogoVariant, type LogoSize } from './styles';

interface SeedLogoProps {
  $variant?: LogoVariant;
  light?: boolean;
  dark?: boolean;
  expanded?: boolean;
  size?: LogoSize;
  fontSize?: string;
  onClick?: () => void;
}

const SeedLogo: FC<SeedLogoProps> = ({
  $variant = 'default',
  light,
  dark,
  expanded = true,
  size = 'fixed',
  fontSize,
  onClick,
}) => (
  <StyledLink
    href='/'
    className='seed-logo'
    onClick={(e) => {
      e.currentTarget.blur();
      if (typeof onClick === 'function') {
        onClick();
      }
    }}
    $variant={$variant}
    $light={light !== undefined ? light : !dark}
    $expanded={expanded}
    $size={size}
    $fontSize={fontSize}
  >
    [logo]
    {$variant === 'practitioners' ? 'for Practitioners' : null}
    <span className='screenreader-only'>Home</span>
  </StyledLink>
);

export default SeedLogo;

/**
 * HOW TO IMPLEMENT - SEED LOGO
 * ---------------
 *
 * @example Light logo (white, on dark/brand background)
 * <SeedLogo light />
 *
 * @example Dark logo (brand green, on light background)
 * <SeedLogo dark />
 *
 * @example Natural height
 * <SeedLogo light size="natural" />
 *
 * @example Collapsed dot (e.g. nav open state)
 * <SeedLogo light expanded={false} />
 *
 * @example Practitioners variant
 * <SeedLogo light $variant="practitioners" />
 *
 * @example Dynamic theme
 * <SeedLogo light={theme === 'white'} />
 */
